import taskTrainingCommitTypes from './commit-types';

const INITIAL_TASK_TRAINING_STATE = {
  taskTrainingMap: {},
  myTaskResponses: []
};

function taskTrainingReducers(state = INITIAL_TASK_TRAINING_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case taskTrainingCommitTypes.SET_TASK_TRAINING:
      return {
        ...state,
        taskTrainingMap: {
          ...state.taskTrainingMap,
          [action.oitGuid]: action.taskTraining
        }
      };

    case taskTrainingCommitTypes.UPDATE_TASK_TRAINING:
      return {
        ...state,
        taskTrainingMap: {
          ...state.taskTrainingMap,
          [action.oitGuid]: state.taskTrainingMap[action.oitGuid]? state.taskTrainingMap[action.oitGuid].map(tt => tt.taskGroupTrainingTrackerGuid === action.guid ? {
            ...tt,
            reference_responses: action.reference_responses
          }: tt): []
        }
      };

    case taskTrainingCommitTypes.SET_MY_TASK_RESPONSES:
      return {
        ...state,
        myTaskResponses: action.myTaskResponses
      };
    case taskTrainingCommitTypes.SET_TASK_RESPONSE_ACK:
      return {
        ...state,
        myTaskResponses: state.myTaskResponses? state.myTaskResponses.map(tr => {
          if (tr.guid === action.taskResponseGuid) {
            return {
              ...tr,
              acknowledgedAt: action.acknowledgedAt
            }
          } else {
            return tr
          }
        }): [],
        taskTrainingMap: {
          ...state.taskTrainingMap,
          [action.oitGuid]:state.taskTrainingMap[action.oitGuid]? state.taskTrainingMap[action.oitGuid].map(taskGroup => ({
            ...taskGroup,
            tasks: taskGroup.tasks.map(task => {
              return {
                ...task,
                taskResponses: task.taskResponses? task.taskResponses.map(tr => tr.guid === action.taskResponseGuid
                  ? {
                    ...tr,
                    acknowledgedAt: action.acknowledgedAt,
                    status: "completed",
                    oitComment: action.ackComment
                  }
                  : tr): []
              }
            })
          })): [],
        }
      };
    case taskTrainingCommitTypes.SET_TASK_RESPONSE_STATUS:
      return {
        ...state,
        taskTrainingMap: {
          ...state.taskTrainingMap,
          [action.oitGuid]: state.taskTrainingMap[action.oitGuid].map(taskGroup => ({
            ...taskGroup,
            tasks: taskGroup.tasks.map(task => {
              if (task.taskGuid === action.taskGuid) {
                return {
                  ...task,
                  taskResponses: task.taskResponses? task.taskResponses.map(tr => tr.guid === action.taskResponseGuid
                    ? {
                      ...tr,
                      status: action.status
                    }
                    : tr): []
                }
              } else {
                return task
              }
            })
          })),
        }
      };
    case taskTrainingCommitTypes.REJECT_TASK_RESPONSE:
      return {
        ...state,
        taskTrainingMap: {
          ...state.taskTrainingMap,
          [action.oitGuid]: state.taskTrainingMap[action.oitGuid].map(taskGroup => ({
            ...taskGroup,
            tasks: taskGroup.tasks.map(task => {
              if (task.taskGuid === action.taskGuid) {
                return {
                  ...task,
                  taskResponses: task.taskResponses? task.taskResponses.map(tr => tr.guid === action.taskResponseGuid
                    ? {
                      ...tr,
                      rejectedBy: action.rejectedBy,
                      rejectedAt: action.rejectedAt,
                      rejectComment: action.rejectComment,
                      status: action.status
                    }
                    : tr): []
                }
              } else {
                return task
              }
            })
          })),
        }
      };
    case taskTrainingCommitTypes.UPDATE_TASK_RESPONSE:
      return {
        ...state,
        taskTrainingMap: {
          ...state.taskTrainingMap,
          [action.oitGuid]: state.taskTrainingMap[action.oitGuid].map(taskGroup => ({
            ...taskGroup,
            tasks: taskGroup.tasks.map(task => {
              if (task.taskGuid === action.taskGuid) {
                return {
                  ...task,
                  taskResponses: task.taskResponses? task.taskResponses.map(tr => tr.guid === action.taskResponseGuid
                    ? {
                      ...tr,
                      action: action.action,
                      actionAt: action.actionAt,
                      authorComment: action.authorComment,
                      status: action.status,
                      acknowledgedAt: null,
                      oitComment: null,
                      substandard: action.substandard
                    }
                    : tr): []
                }
              } else {
                return task
              }
            })
          })),
        }
      };
    case taskTrainingCommitTypes.ADD_TASK_RESPONSES:
      return {
        ...state,
        taskTrainingMap: {
          ...state.taskTrainingMap,
          [action.oitGuid]: state.taskTrainingMap[action.oitGuid].map(taskGroup => ({
            ...taskGroup,
            tasks: taskGroup.tasks.map(task => {
              if (task.taskGuid === action.taskGuid) {
                return {
                  ...task,
                  taskResponses: [
                    ...task.taskResponses,
                    ...action.taskResponses
                  ]
                }
              } else {
                return task
              }
            })
          })),
        }
      };
    default:
      return state;
  }
}

export default taskTrainingReducers;
